import React, { useState, useEffect } from "react";
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/components/modal/modalDialog';
import { ReactPlanner, Plugins as PlannerPlugins } from 'react-planner';
import * as MyCatalog from '../../../catalog/mycatalog';
import * as GasInstallCatalog from '../../../catalog/gasInstallCatalog';
import * as HeathInstallCatalog from '../../../catalog/heathInstallCatalog';
import Button from "@material-ui/core/Button";
import ContainerDimensions from 'react-container-dimensions';
import blue from '@material-ui/core/colors/blue';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize, faWindowRestore } from '@fortawesome/free-regular-svg-icons';
import { faTimes, faCopy, faPaste, faCalculator, faCube, faWrench } from '@fortawesome/free-solid-svg-icons';
import IconButton from '@material-ui/core/IconButton';
import { OfferSteps, CategoryType, OfferStatus } from '../../../common/enums';
import LocalProductsService from '../../../services/localDataServices/localProductsService';
import Spinner from "../../../common/components/spinner/spinner";
import { Catalog } from 'react-planner';
import LocalCategoryService from '../../../services/localDataServices/localCategoryService';
import Translate from "../../../common/functions/translate";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { ElementsFactories } from 'react-planner';
import useWindowDimensions from '../../../common/functions/windowDimentionHook';
import * as Items from '../../../catalog/items/index';
import * as Constants from '../../../common/constants';

let plugins = [
    PlannerPlugins.Keyboard(),
    PlannerPlugins.Autosave('react-planner_v0'),
    PlannerPlugins.ConsoleDebugger(),
];

let localProductsService = new LocalProductsService();
let localCategoryService = new LocalCategoryService();

let initLayers = (catalogType, planner, onlyPan, axonometricView, copiedLayer?) => {
    let newCat = new Catalog();
    if (catalogType === OfferSteps.TwoDPlan) {
        newCat = MyCatalog.GetCatalog();
        planner.layers["layer-1"].visible = true;
        planner.layers["layer-2"].visible = false;
        planner.layers["layer-3"].visible = false;
        planner.selectedLayer = "layer-1";
    }
    else if (catalogType === OfferSteps.GasInstallation || catalogType === OfferSteps.GenerateOffer) {
        newCat = GasInstallCatalog.GetCatalog();
        planner.layers["layer-1"].visible = true;
        planner.layers["layer-2"].visible = true;
        planner.layers["layer-2"].opacity = 1;
        planner.layers["layer-3"].visible = true;
        planner.layers["layer-3"].opacity = onlyPan && axonometricView ? 0 : 0.5;
        planner.selectedLayer = "layer-2";
    }

    else if (catalogType === OfferSteps.HeatingInstallation) {
        newCat = HeathInstallCatalog.GetCatalog();
        planner.layers["layer-1"].visible = true;
        planner.layers["layer-2"].visible = true;
        planner.layers["layer-2"].opacity = onlyPan && axonometricView ? 0 : 0.5;
        planner.layers["layer-3"].visible = true;
        planner.layers["layer-3"].opacity = 1;
        planner.selectedLayer = "layer-3";
    }
    if (copiedLayer) {
        let copyPlanner = localStorage.getItem('copyPlanner');
        if (copyPlanner) {
            let parsedPlanner = JSON.parse(copyPlanner);
            let copiedLayer = parsedPlanner.copiedLayer
            let width = parsedPlanner.copiedWidth;
            let height = parsedPlanner.copiedHeight;
            planner.layers['layer-1'] = JSON.parse(copiedLayer);
            planner.width = JSON.parse(width);
            planner.height = JSON.parse(height);
        }
    }

    planner = HelperFunctions.plannerVersionUpdates(planner);

    localStorage.setItem('react-planner_v0', JSON.stringify(planner));

    return newCat
}

class TreeNodeModel {
    public key: string;
    public label: string;
    public data: any;
    public children: Array<TreeNodeModel>
}

let createTree = (parentId, categories) => {
    let subTree = new Array<TreeNodeModel>(0);

    categories
        .filter(f => parentId ? f.parentId === parentId : f.parentId === null)
        .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
        .map(f => {
            let node = new TreeNodeModel();
            node.key = f.remoteId.toString();
            node.label = f.name;
            node.data = { ...f };
            if (categories.some(a => a.parentId === f.remoteId)) {
                node.children = createTree(f.remoteId, categories);
            };
            subTree.push(node);
            return 0;
        });

    return subTree;
}

let idInCategory = (categoryId, category) => {
    let inCategory = false;
    if (categoryId === +category.key && category.data.categoryTypeId !== CategoryType.Services &&
        category.data.categoryTypeId !== CategoryType.Materials && category.data.categoryTypeId !== CategoryType.Labor) {
        inCategory = true;
    }
    else {
        if (category.children && category.children.length > 0) {
            category.children.forEach(child => {
                if (idInCategory(categoryId, child)) {
                    inCategory = true;
                }
            });
        }
    }
    return inCategory;
}

let createAllCategories = (tree, catalog, hidden) => {
    tree.forEach(element => {
        if (element.data.categoryTypeId !== CategoryType.Services && element.data.categoryTypeId !== CategoryType.Materials &&
            element.data.categoryTypeId !== CategoryType.Labor) {
            let newCat = catalog.registerCategory(element.key, element.label, [], hidden);
            if (element.data.parentId && catalog.hasCategory(element.data.parentId + '')) {
                catalog.addToCategory(element.data.parentId + '', newCat)
            }
            if (element.children) {
                createAllCategories(element.children, catalog, hidden);
            }
        }
    });

    return catalog;
}

const theme = createMuiTheme({
    overrides: {
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '100%'
            },
            paperWidthSm: {
                width: '100%',
                maxWidth: 1000,
                height: '100%'
            }
        },
        MuiDialogTitle: {
            root: {
                padding: '0px 0px 0px 10px !important'
            }
        }
    },
    palette: {
        primary: blue
    }
});

let addItemsToCatalog = (catalog, elementsList, catalogType, searchedCatalog, categories, productImages) => {
    elementsList.forEach(element => {
        let cat = categories.find(r => r.remoteId === element.categoryId);
        let packageCat = categories.find(r => r.categoryTypeId === CategoryType.Packages);
        let materialsCat = categories.filter(r => r.categoryTypeId === CategoryType.Materials);
        let laborsCat = categories.filter(r => r.categoryTypeId === CategoryType.Labor);
        let servicesCat = categories.filter(r => r.categoryTypeId === CategoryType.Services);
        let isFromPackage = false;
        if (cat) {
            isFromPackage = cat.categoryTypeId === CategoryType.Packages;
        }
        if (!isFromPackage) {
            let newelement = getElement(catalog, element, productImages, categories);
            catalog.registerElement(newelement);
            if (catalogType === searchedCatalog && catalog.hasCategory(element.categoryId + '')) {
                catalog.addToCategory(element.categoryId + '', newelement)
            }
            else {
                catalog.addToCategory('hidden', newelement);
            }
        }
        else {
            if (element.relatedProducts && element.relatedProducts.length > 0) {
                element.relatedProducts.forEach(relEl => {
                    if (!materialsCat || !servicesCat || !laborsCat ||
                        (!materialsCat.some(r => r.remoteId === relEl.relatedProduct.categoryId) &&
                            !servicesCat.some(r => r.remoteId === relEl.relatedProduct.categoryId) &&
                            !laborsCat.some(r => r.remoteId === relEl.relatedProduct.categoryId))) {
                        if (!catalog.hasCategory(element.remoteId + 'package')) {
                            let newElement = getElement(catalog, relEl.relatedProduct, productImages, categories);
                            catalog.registerElement(newElement);
                            let newCat = catalog.registerCategory(element.remoteId + 'package', element.article, [newElement], false);
                            if (packageCat && catalog.hasCategory(packageCat.remoteId + ""))
                                catalog.addToCategory(packageCat.remoteId + "", newCat);
                        }
                        else {
                            let newElement = getElement(catalog, relEl.relatedProduct, productImages, categories);
                            catalog.registerElement(newElement);
                            catalog.addToCategory(element.remoteId + 'package', newElement);
                        }
                    }
                });
            }
        }
    });
    return catalog;
}

let getElement = (catalog, element, productImages, categories) => {
    let newElement = {};
    if (catalog.hasElement(element.remoteId + "")) {
        newElement = catalog.getElement(element.remoteId + "");
    }
    else {
        newElement = HelperFunctions.createNewCategoryElement(element, productImages, categories);
        //catalog.registerElement(newElement);
    }
    return newElement
}

let getSvgElement = (width, height, plannerHeight, axonometricView) => {
    let svgNode = getSVGNode();

    let maxWidthSVGElement = svgNode.cloneNode(true) as SVGSVGElement;

    let schemeG = getSchemeG();

    let x = 0;
    let y = 0;

    let viewBoxWidth = width;
    let viewBoxHeight = height;

    maxWidthSVGElement.setAttribute('width', width);;
    maxWidthSVGElement.setAttribute('height', height);

    if (schemeG) {
        let bcr = schemeG.getBoundingClientRect();
        let bb = schemeG.getBBox();

        var pt = maxWidthSVGElement.createSVGPoint();
        pt.x = bcr.x;
        pt.y = bcr.y;
        let res = pt.matrixTransform(schemeG.getScreenCTM()?.inverse());

        if (res) {
            x = res.x - 40;
            y = plannerHeight - res.y - 40;
        }

        viewBoxWidth = bb.width + 80;
        viewBoxHeight = bb.height + 80;
    }

    let gridsLines = maxWidthSVGElement.getElementById('grid-lines');

    if (gridsLines) {
        gridsLines.remove();
    }

    let outerHTMl: string = '';

    let viewBox = ` viewBox="${x} ${y} ${viewBoxWidth} ${viewBoxHeight}"`;
    outerHTMl = maxWidthSVGElement.outerHTML;
    outerHTMl = [outerHTMl.slice(0, 4), viewBox, outerHTMl.slice(4)].join('');
    outerHTMl = outerHTMl.replace(/<g.*?>/, '<g>');
    // outerHTMl = outerHTMl.replace(/height=".*?"/, `height="${height}"`);
    // outerHTMl = outerHTMl.replace(/width=".*?"/, `width="${width}"`);
    if (!axonometricView)
        outerHTMl = outerHTMl.replace(/opacity="0.5"/g, 'opacity="1"');
    else
        outerHTMl = outerHTMl.replace(/opacity="0.5"/g, 'opacity="0"');

    return outerHTMl;
}

let getSchemeG = () => {
    var svg = getSVGNode();

    var gs = svg.getElementById('scheme-wrapper');

    if (gs) {
        return gs as SVGGElement;
    } else {
        return null;
    }
}

let getSVGNode = () => {
    let svgElements = document.getElementsByTagName('svg');

    let maxWidthSVGElement = svgElements[0];
    for (let i = 1; i < svgElements.length; i++) {
        if (svgElements[i].width.baseVal.value > maxWidthSVGElement.width.baseVal.value) {
            maxWidthSVGElement = svgElements[i];
        }
    }

    return maxWidthSVGElement;
}

let handleSave = (props, isSaveAndClose, categoryPackId, isAxonometric) => {
    let planner: any = localStorage.getItem('react-planner_v0');
    let width = 2000;
    let height = 1500;
    let plannerHeight = 1500;

    if (planner) {
        planner = JSON.parse(planner);
        width = planner.width;
        height = planner.height;
        plannerHeight = planner.height;
    }

    if (isAxonometric) {
        width = width + (width / 2.2);
        height = height + 200;
    }

    let twoDHTML = getSvgElement(width, height, plannerHeight, isAxonometric);
    // let imgSrc = '';
    // if (props.catalogType === OfferSteps.TwoDPlan) {
    //     let node = getSVGNode();
    //     let viewBox = ` viewBox="0 0 ${width} ${height}"`;
    //     let serializer = new XMLSerializer();
    //     let ser = serializer.serializeToString(node);
    //     ser = [ser.slice(0, 4), viewBox, ser.slice(4)].join('');
    //     ser = ser.replace(/<g.*?>/, '<g>');
    //     let utf8Bytes = encodeURIComponent(ser).replace(/%([0-9A-F]{2})/g, (match, p1: string) => {
    //         // @ts-ignore
    //         return String.fromCharCode('0x' + p1);
    //     });
    //     imgSrc = `data:image/svg+xml;base64,${window.btoa(utf8Bytes)}`;
    // }
    if (isSaveAndClose)
        props.toggle(false, false);
    props.saveClick(props.catalogType, twoDHTML, isSaveAndClose, categoryPackId, isAxonometric, props.onlyPan);
}

let copyLayer = (setHasCopiedLayer) => {
    let planner: any = localStorage.getItem('react-planner_v0');
    if (planner) {
        planner = JSON.parse(planner);
        let layerForCopy = JSON.stringify(planner.layers['layer-1']);
        let width = JSON.stringify(planner.width);
        let height = JSON.stringify(planner.height);
        let copyPlanner = { copiedLayer: layerForCopy, copiedWidth: width, copiedHeight: height }
        localStorage.setItem('copyPlanner', JSON.stringify(copyPlanner));
        setHasCopiedLayer(true);
    }
}

let pasteLayer = (setLoading) => {
    setLoading(true);
    let planner: any = localStorage.getItem('react-planner_v0');
    if (planner) {
        planner = JSON.parse(planner);

        let copyPlanner = localStorage.getItem('copyPlanner');
        if (copyPlanner) {
            let parsedPlanner = JSON.parse(copyPlanner);
            let copiedLayer = parsedPlanner.copiedLayer
            let width = parsedPlanner.copiedWidth;
            let height = parsedPlanner.copiedHeight;
            planner.layers['layer-1'] = JSON.parse(copiedLayer);
            planner.width = JSON.parse(width);
            planner.height = JSON.parse(height);
            localStorage.setItem('react-planner_v0', JSON.stringify(planner));
        }
    }
    setTimeout(() => {

        setLoading(false);
    });
}

let checkItemsFromPlanner = (catalog, planner, catalogType) => {
    for (let layer in planner.layers) {
        for (let item in planner.layers[layer].items) {
            let found = catalog.elements[planner.layers[layer].items[item].type];
            if (!found || found === undefined || found === null) {
                let element = HelperFunctions.newVoidElement(planner.layers[layer].items[item].type,
                    planner.layers[layer].items[item].name,
                    planner.layers[layer].items[item].desc);
                catalog.registerElement(element);
                catalog.addToCategory('hidden', element);
            }
        }

        for (let pipe in planner.layers[layer].pipes) {
            let found = catalog.elements[planner.layers[layer].pipes[pipe].type];
            if (!found || found === undefined || found === null) {
                const info = {
                    title: planner.layers[layer].pipes[pipe].name,
                    tag: ['pipe'],
                    description: planner.layers[layer].pipes[pipe].desc,
                    image: require('../../../catalog/pipes/gas/pipe.png'),
                    visibility: {
                        catalog: true,
                        layerElementsVisible: true
                    }
                };

                let element = {};
                if (catalogType === OfferSteps.GasInstallation)
                    element = ElementsFactories.PipeFactoryGas(planner.layers[layer].pipes[pipe].type, info, null);
                else
                    element = ElementsFactories.PipeFactoryWater(planner.layers[layer].pipes[pipe].type, info, null);

                catalog.registerElement(element);
                catalog.addToCategory('hidden', element);
            }
        }
    }
}

const PlannerDialogComponent = (props: any) => {
    const [isFullScreen, setFullScreen] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [innerLoading, setInnerLoading] = useState(false);
    const [catalog, setCatalog] = useState(new Catalog());
    const [unselectAllBool, setUnselect] = useState(false);
    const [isSaved, setSaved] = useState(false);
    const [categoryPackId, setCategoryPackId] = useState(0);
    const [hasCopiedLayer, setHasCopiedLayer] = useState(localStorage.getItem('copyPlanner') ? true : false);
    const [axonometricView, setView] = useState(props.isAxonometric);
    const [firstSet, setFirst] = useState(false);
    const { width } = useWindowDimensions();

    useEffect(() => {
        if (props.catalogType === OfferSteps.GasInstallation && props.pipeInfo && props.pipeInfo.pipes && props.pipeInfo.pipes.length > 0) {
            setInnerLoading(true);
            let layer = 'layer-2';
            let planner: any = localStorage.getItem('react-planner_v0');
            if (planner) {
                planner = JSON.parse(planner);
                for (let pipe of props.pipeInfo.pipes) {
                    if (planner.layers[layer].pipes[pipe.plannerName]) {
                        planner.layers[layer].pipes[pipe.plannerName].properties.diameter.length = pipe.diameter;
                    }

                    if (planner.layers[layer].items[pipe.plannerName]) {
                        planner.layers[layer].items[pipe.plannerName].properties.diameter.length = pipe.diameter;
                    }
                }
                localStorage.setItem('react-planner_v0', JSON.stringify(planner));
            }

            setTimeout(() => {
                setInnerLoading(false);
            });
        }
    }, [props.pipeInfo, props.catalogType])


    useEffect(() => {
        localCategoryService.getAllCategories().then(
            (categories: any) => {
                let tree = createTree(null, categories);
                let found = categories.find(r => r.categoryTypeId === CategoryType.Packages)
                if (found)
                    setCategoryPackId(found.remoteId);
                localProductsService.getProductImages().then(
                    (productImages: any) => {
                        localProductsService.getAllProducts().then(
                            (products: any) => {
                                let newCat: Catalog = new Catalog();
                                newCat = initLayers(props.catalogType, props.planner, props.onlyPan, props.isAxonometric, props.copiedLayer);
                                let gasinstall: Array<any> = [];
                                let heathInstall: Array<any> = [];

                                products.forEach(element => {
                                    if (tree.findIndex(r => r.data.categoryTypeId === CategoryType.GasInstallation) !== -1 &&
                                        idInCategory(element.categoryId, tree.find(r => r.data.categoryTypeId === CategoryType.GasInstallation))) {
                                        gasinstall.push(element)
                                    } else if (tree.findIndex(r => r.data.categoryTypeId === CategoryType.HeatInstallation) !== -1 &&
                                        idInCategory(element.categoryId, tree.find(r => r.data.categoryTypeId === CategoryType.HeatInstallation))) {
                                        heathInstall.push(element);
                                    }
                                });

                                let gasinstallFound = tree.find(r => r.data.categoryTypeId === CategoryType.GasInstallation);
                                if (gasinstallFound) {
                                    newCat = createAllCategories(gasinstallFound.children, newCat, props.catalogType !== OfferSteps.GasInstallation);
                                }

                                let heathInstallFound = tree.find(r => r.data.categoryTypeId === CategoryType.HeatInstallation);
                                if (heathInstallFound) {
                                    newCat = createAllCategories(heathInstallFound.children, newCat, props.catalogType !== OfferSteps.HeatingInstallation);
                                }

                                addItemsToCatalog(newCat, gasinstall, props.catalogType, OfferSteps.GasInstallation, categories, productImages);
                                addItemsToCatalog(newCat, heathInstall, props.catalogType, OfferSteps.HeatingInstallation, categories, productImages);

                                checkItemsFromPlanner(newCat, props.planner, props.catalogType);

                                let pipesCats = categories.filter(r => r.categoryTypeId === CategoryType.Pipes);
                                pipesCats.forEach(cat => {
                                    if (tree.findIndex(r => r.data.categoryTypeId === CategoryType.GasInstallation) !== -1 &&
                                        idInCategory(cat.remoteId, tree.find(r => r.data.categoryTypeId === CategoryType.GasInstallation))
                                        && newCat.hasCategory(cat.remoteId + '') && props.catalogType === OfferSteps.GasInstallation) {
                                        newCat.addToCategory(cat.remoteId + '', Items.VerticalGasPipe);
                                    }
                                    if (tree.findIndex(r => r.data.categoryTypeId === CategoryType.HeatInstallation) !== -1 &&
                                        idInCategory(cat.remoteId, tree.find(r => r.data.categoryTypeId === CategoryType.HeatInstallation))
                                        && newCat.hasCategory(cat.remoteId + '') && props.catalogType === OfferSteps.HeatingInstallation) {
                                        newCat.addToCategory(cat.remoteId + '', Items.VerticalWaterPipe);
                                    }
                                });

                                setCatalog(newCat);
                                setLoading(false);
                                //Removin white lines 
                                if (!firstSet) {
                                    setFirst(true);
                                    setTimeout(() => {
                                        setFullScreen(true);
                                    });
                                }
                            }).catch(err => console.log(err));
                    }).catch(err => console.log(err))
            }
        ).catch(err => console.log(err));


    }, [props.catalogType, props.planner, props.copiedLayer, props.onlyPan, props.isAxonometric, firstSet])

    let layerForHide = props.catalogType === OfferSteps.GasInstallation ? 'layer-3' : 'layer-2';
    if (props.catalogType === OfferSteps.TwoDPlan)
        layerForHide = '';

    return (<>
        {isLoading ? <Spinner /> :
            <MuiThemeProvider theme={theme}>
                <Dialog
                    disableEscapeKeyDown
                    open={props.isOpen}
                    onClose={() => props.toggle(false, isSaved)}
                    fullScreen={isFullScreen}
                >
                    <Modal.DialogTitle id="customized-dialog-title" >
                        <div className="step-header-dialog">
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", height: '100%' }}>
                                <div>
                                    {/* {props.activeStepNumber} */}
                                    {`${Translate('Offer')} - ${props.offer.offerNumber} ${props.activeStep}`}
                                </div>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <div onClick={() => setFullScreen(!isFullScreen)}>
                                        <IconButton aria-label="add">
                                            {isFullScreen ? <FontAwesomeIcon icon={faWindowRestore} /> :
                                                <FontAwesomeIcon icon={faWindowMaximize} />}
                                        </IconButton>
                                    </div>
                                    <div onClick={() => props.toggle(false, isSaved)}>
                                        <IconButton aria-label="add">
                                            <FontAwesomeIcon icon={faTimes} />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.DialogTitle>
                    <Modal.DialogPlannerContent>
                        {innerLoading ? <Spinner /> :
                            <div style={{ width: '100%', height: '100%' }}>
                                <ContainerDimensions>
                                    {({ width, height }) =>
                                        <ReactPlanner
                                            catalog={catalog}
                                            width={width}
                                            height={height}
                                            plugins={plugins}
                                            stateExtractor={state => state.planner.get('react-planner')}
                                            hideLayers={true}
                                            unselectAll={unselectAllBool}
                                            axonometricView={axonometricView}
                                            onlyPan={props.onlyPan}
                                            layerForHide={layerForHide}
                                        />
                                    }
                                </ContainerDimensions>
                            </div>}
                    </Modal.DialogPlannerContent>
                    <Modal.DialogActions>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                            <div>
                                {props.catalogType === OfferSteps.TwoDPlan ?
                                    <div>
                                        <Button onClick={() => copyLayer(setHasCopiedLayer)} style={{ marginRight: 10 }} variant="outlined" color="primary">
                                            <FontAwesomeIcon icon={faCopy} style={{ fontSize: 20, marginRight: 5 }} />
                                            {width > Constants.smallBtnWidth ? Translate('Copy') : null}
                                        </Button>
                                        {props.offer.offerStatusId === OfferStatus.NewOffer || props.offer.offerStatusId === OfferStatus.Expired ?
                                            <Button onClick={() => pasteLayer(setInnerLoading)} style={{ marginRight: 10 }} color="primary" variant="outlined" disabled={!hasCopiedLayer}>
                                                <FontAwesomeIcon icon={faPaste} style={{ fontSize: 20, marginRight: 5 }} />
                                                {width > Constants.smallBtnWidth ? Translate('Paste') : null}
                                            </Button> : null}
                                    </div> :
                                    <>{!props.onlyPan ?
                                        <div className="planner-dialog-btns">
                                            {!props.offer.equipmentOnly
                                                ? <Button
                                                    className="planner-dialog-btn"
                                                    onClick={() => {
                                                        setView(!axonometricView);
                                                    }
                                                    } style={{ marginRight: 10 }} variant="outlined" color="primary">
                                                    <FontAwesomeIcon icon={faCube} style={{ fontSize: 20, marginRight: 5 }} />
                                                    {width > Constants.smallBtnWidth ?
                                                        Translate(axonometricView ? '2DScheme' : 'AxonometricScheme') : null}
                                                </Button>
                                                : null}
                                            {props.catalogType === OfferSteps.GasInstallation && !props.offer.equipmentOnly ?
                                                <Button onClick={() => {
                                                    setTimeout(() => {
                                                        props.calculatePipes()
                                                    })
                                                }} style={{ marginRight: 10 }} variant="outlined" color="primary"
                                                    className="planner-dialog-btn">
                                                    <FontAwesomeIcon icon={faCalculator} style={{ fontSize: 20, marginRight: 5 }} />
                                                    {width > Constants.smallBtnWidth ? Translate('CalculatePipes') : null}
                                                </Button> : null}
                                            {props.catalogType === OfferSteps.GasInstallation && !props.offer.equipmentOnly ?
                                                <Button onClick={() => {
                                                    setTimeout(() => {
                                                        props.addFittings()
                                                    })
                                                }} variant="outlined" color="primary"
                                                    className="planner-dialog-btn">
                                                    <FontAwesomeIcon icon={faWrench} style={{ fontSize: 20, marginRight: 5 }} />
                                                    {width > Constants.smallBtnWidth ? Translate('AddFittings') : null}
                                                </Button> : null}
                                        </div>
                                        : <div />}
                                    </>}
                            </div>

                            <div className="planner-dialog-btns">
                                <Button onClick={() => props.toggle(false, isSaved)} variant="contained" style={{ marginRight: 10 }} className="planner-dialog-btn">
                                    {Translate("Close")}
                                </Button>
                                {props.offer.offerStatusId === OfferStatus.NewOffer || props.offer.offerStatusId === OfferStatus.Expired ?
                                    <>
                                        <Button onClick={() => {
                                            setUnselect(!unselectAllBool);
                                            setTimeout(() => {
                                                setSaved(true);
                                                handleSave(props, false, categoryPackId, axonometricView);
                                            });
                                        }} color="primary" variant="contained" style={{ marginRight: 10 }} className="planner-dialog-btn">
                                            {Translate("Save")}
                                        </Button>
                                        <Button onClick={() => {
                                            setUnselect(!unselectAllBool);
                                            setTimeout(() => {
                                                handleSave(props, true, categoryPackId, axonometricView);
                                            });
                                        }} color="secondary" variant="contained" className="planner-dialog-btn">
                                            {Translate("Save & Close")}
                                        </Button>
                                    </> : null
                                }
                            </div>
                        </div>
                    </Modal.DialogActions>
                </Dialog >
            </MuiThemeProvider>
        }
    </>
    )

}

export default PlannerDialogComponent;
